import { HubTooltip } from '../HubTooltip';

/**
 * @deprecated Use {@link HubTooltip} instead.
 */

/**
 * Display a box with a pointer to an element.
 *
 * Callout does not handle any conditional rendering.
 * Conditional rendering should be handled by the component that uses Callout.
 *
 * @deprecated Use {@link HubTooltip} instead.
 */
export function Callout({
  children,
  targetRef,
  position = 'center',
  horizontal,
  tooltip = true
}) {
  return <HubTooltip
  // Our `DropdownTransition` does not respect `timeout`, but Material UI's default transition does.
  TransitionComponent={undefined} TransitionProps={{
    // Make callout appear immediately like it did before we used Material UI's tooltip.
    timeout: 0
  }}
  // Callouts must be "interactive". If we disable interactivity,
  // `pointer-events: none` will be added to the popper element and Cypress
  // will consider the callout to not be visible. Also, when this happens,
  // Cypress gives a bogus error saying the callout is covered by another
  // element.
  disableInteractive={false} title={children} placement={tooltip ? position === 'left' ? 'left' : horizontal === 'left' ? 'bottom-start' : horizontal === 'right' ? 'bottom-end' : 'bottom' : 'right-start'} PopperProps={{
    anchorEl: targetRef.current
  }} open styles={{
    tooltip: {
      maxWidth: 'none'
    }
  }} arrow={tooltip} slotProps={{
    tooltip: {
      // @ts-expect-error `data-*` attributes are not in the type definition
      'data-testid': 'callout'
    }
  }}>
			{/* This div is a dummy element. Material UI Tooltip requires a child. */}
			<div hidden />
		</HubTooltip>;
}